import { withInstall } from '../utils'
import _Select from './Select'
import './index.scss'

export const Select = withInstall(_Select)
export default Select
